var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 6.41064H15.6342V7.60112H4.91992V6.41064ZM4.91992 9.68445H15.6342V10.8749H4.91992V9.68445ZM4.91992 12.9583H10.5747V14.1487H4.91992V12.9583Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.61 2.5415H1.94336V18.0177H18.61V2.5415ZM17.4195 16.8272H3.13384V3.73198H17.4195V16.8272Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesListIcon);
export default __webpack_public_path__ + "static/media/notes-list-icon.b9dfd8e50a902cc6fceb0dc0bfcdcc5d.svg";
export { ForwardRef as ReactComponent };